var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileMenuClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.333496C3.32732 0.333496 0.333984 3.32683 0.333984 7.00016C0.333984 10.6735 3.32732 13.6668 7.00065 13.6668C10.674 13.6668 13.6673 10.6735 13.6673 7.00016C13.6673 3.32683 10.674 0.333496 7.00065 0.333496ZM9.66732 7.50016H7.50065V9.66683C7.50065 9.94016 7.27398 10.1668 7.00065 10.1668C6.72732 10.1668 6.50065 9.94016 6.50065 9.66683V7.50016H4.33398C4.06065 7.50016 3.83398 7.2735 3.83398 7.00016C3.83398 6.72683 4.06065 6.50016 4.33398 6.50016H6.50065V4.3335C6.50065 4.06016 6.72732 3.8335 7.00065 3.8335C7.27398 3.8335 7.50065 4.06016 7.50065 4.3335V6.50016H9.66732C9.94065 6.50016 10.1673 6.72683 10.1673 7.00016C10.1673 7.2735 9.94065 7.50016 9.66732 7.50016Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuClose);
export default __webpack_public_path__ + "static/media/mobile-menu-close.50995c924f043dd11bc0b083c3b1fa9a.svg";
export { ForwardRef as ReactComponent };